module.exports = __webpack_public_path__ + "img/emoji_27.b2f2a0db.png";